export default __webpack_public_path__ + "static/media/xlsxIcon-white.1184f30f.png";